import { render, staticRenderFns } from "./tarifications.html?vue&type=template&id=07cfa010&scoped=true&external"
import script from "./tarifications.js?vue&type=script&lang=js&external"
export * from "./tarifications.js?vue&type=script&lang=js&external"
import style0 from "./tarifications.scss?vue&type=style&index=0&id=07cfa010&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfa010",
  null
  
)

export default component.exports